<template>
  <div class="nav-vertical py-0 filterItemWithCategoriesContainer">
    <c-filter-item-heading
      v-if="item.heading"
      v-bind="item.heading"
      @back="onBackButtonClicked"
      :aria-label="$t('ui.seeAllFilterOptions')"
      :show-chevron="showChevron"
      :showBackButton="!!activeCategory"
    ></c-filter-item-heading>
    <c-filter-item-categories
      :categories="activeCategories"
      :active-category="activeCategory"
      :show-tags="showTags"
      @category-selected="onCategorySelected"
      @reset-category="onResetCategory"
      @reset-tag="onResetTag"
      @tag-selected="onTagSelected"
    >
      <span
        class="filterItemMessage px-1"
        v-if="item.message"
        :tabindex="item.messageTabIndex || 0"
      >
        {{ item.message }}
      </span>
    </c-filter-item-categories>
    <span class="visuallyhidden"> {{ activeCategories.length }} categories available. </span>
  </div>
</template>

<script>
import FilterItemCategories from '@/components/pages/filter/categories/FilterItemCategories'
import FilterItemHeading from '@/components/pages/filter/FilterItemHeading'

export default {
  components: {
    'c-filter-item-categories': FilterItemCategories,
    'c-filter-item-heading': FilterItemHeading,
  },
  props: { item: { required: true, type: Object }, showChevron: Boolean },
  data: () => ({}),
  computed: {
    activeCategory() {
      const { getActiveCategoryFromTag, selectedCategory, selectedTag } = this
      if (selectedCategory) return selectedCategory
      else if (selectedTag) return getActiveCategoryFromTag
      else return null
    },
    activeCategories() {
      if (this.activeCategory) return [this.activeCategory]
      else return this.categories
    },
    categories() {
      return this.item.categories
    },
    getActiveCategoryFromTag() {
      const { categories, selectedTag } = this
      return categories.find(c => c.tags.find(t => t && selectedTag && t.text === selectedTag.text))
    },
    selectedCategory() {
      return this.$store.getters['search/selectedCategory']
    },
    selectedTag() {
      return this.$store.getters['search/selectedTag']
    },
    showTags() {
      return !!this.activeCategory
    },
  },
  methods: {
    onBackButtonClicked() {
      this.onResetCategory()
      this.$forceUpdate()
    },
    onCategorySelected(e) {
      if (e !== this.selectedCategory) this.$store.commit('search/setSelectedCategory', e)
      else this.resetCategory()
      this.$emit('filter-selected', { category: this.selectedCategory })
    },
    onResetCategory() {
      this.resetCategory()
      this.$emit('filter-selected', { category: this.selectedCategory })
    },
    onResetTag() {
      this.resetTag()
      this.$emit('filter-selected', { tag: this.selectedTag })
    },
    onTagSelected(e) {
      if (e !== this.selectedTag) this.$store.commit('search/setSelectedTag', e)
      else this.resetTag()
      this.$emit('filter-selected', { tag: this.selectedTag })
    },
    resetCategory() {
      this.$store.commit('search/setSelectedCategory', null)
      this.$store.commit('search/setSelectedTag', null)
    },
    resetTag() {
      this.$store.commit('search/setSelectedTag', null)
    },
  },
}
</script>

<style lang="scss" scoped>
span.filterItemMessage:focus {
  outline: 3px solid #EA5D4E;
  // color: rgb(0, 0, 0);
  // background-color: rgb(254, 212, 122);
  // box-shadow: rgb(254 212 122) 0px -2px, rgb(33 43 50) 0px 4px;
  // outline: 0px;
}
</style>
